import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import React from "react";
export const bugsnagClient = Bugsnag.start({
    apiKey: process.env.MIX_BUGSNAG_API_KEY || "12345678123456781234567812345678",
    releaseStage: process.env.MIX_APP_ENV,
    plugins: [new BugsnagPluginReact(React)],
    onError: (event) => {
        var _a;
        // Do not send if no key is set
        if (!process.env.MIX_BUGSNAG_API_KEY) {
            return false;
        }
        if (((_a = event.errors[0]) === null || _a === void 0 ? void 0 : _a.errorMessage) === "Network Error") {
            return false;
        }
    },
});
export const notifyError = (error) => {
    bugsnagClient.notify(error);
};
// @ts-ignore plugin exists
export const ErrorBoundary = bugsnagClient
    .getPlugin("react")
    .createErrorBoundary(React);
